import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChildFn,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import * as CountryActions from '@app/modules/countries/actions/country-api.actions';
import { CountryService } from '@app/modules/countries/services/country.service';
import { State } from '@app/reducers';
import { Store } from '@ngrx/store';
import { catchError, map, tap } from 'rxjs/operators';

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const countryService = inject(CountryService);
	const router = inject(Router);
	const store = inject(Store<State>);

	return countryService.get(route.params['id']).pipe(
		map((country) => CountryActions.GetSuccess(country)),
		tap((action: any) => store.dispatch(action)),
		map((country) => !!country),
		catchError(() => {
			return router.navigate(['/not-found']);
		})
	);
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
	canActivate(route, state);
